import rules from '@scoutgg/scoring-rules'
import { Event } from '../models'
import { prompt } from '@scoutgg/ftw/source/services/modal'

var states = {}

const mainEvents = {
  football: [
    'goal',
    'substitution_1',
    'keeper_save',
    'card',
    'own_goal',
    'blunder',
    'foul_commited',
    'fouls_drawn',
    'penalty_save',
    'penalty_miss',
    'bonus',
    'penalty_round',
    'ball_out_of_play',
    'shot_on_target',
  ],
  hockey: [
    'goal',
    'penalty',
    'team_victory',
    'shootout_caused',
    'clean_sheet',
    'shootout_won',
    'shootout_goal',
  ],
  basket: [
    'threepoint_goal',
    'field_goal',
    'freethrow_goal',
  ],
  curling: [
    'curling_end',
  ],
  dota2: [
    'first_blood',
    'kill',
    'assist',
    'death',
    'creep_kill',
    'creep_deny',
    'building_destruction',
    'roshan_kill',
    'wards_placed',
    'wards_destroyed',
    'camp_stack',
    'core_camp_stack',
    'rune_pickup',
    'hero_healing',
    'courier_kill',
    'stun',
    'map_ended',
    'map_win',
    'map_started',
  ],
  cricket: [
    'caught',
    'wicket',
    'extras',
    'run_out',
    'run_out_thrown',
    'duck_dismissal',
    'stumping',
  ],
  rugby_union: [
    'try_goal',
    'conversion',
    'conversion_miss',
    'drop_goal',
    'substitution_1',
    'penalty_goal',
    'penalty_miss',
    'yellow_card',
    'red_card',
  ],
  tennis: [
    'game_won',
    'quick_sets',
    'ace',
    'double_fault',
    'break_won',
    'retired',
    'SSB',
    'knocked_out'
  ],
  american_football: [
    'touchdown',
    'conversion',
    'extra_point',
  ],
  futsal: [
    'goal',
    'card',
    'first_man_of_the_match',
    'second_man_of_the_match',
    'penalty_miss',
    'assist',
    'save_penalty',
    'own_goal',
    'cause_penalty',
    'cause_freekick_goal',
  ],
  biathlon: [
    'shooting_relay',
    'shooting_other',
  ],
  baseball: [
    'scored_run',
    'strikeout',
    'single',
    'double',
    'triple',
    'home_run',
    'stolen_base',
    'earned_run',
    'inning_pitched',
    'hit_against',
    'lost_base',
    'batter_hit',
    'rbi',
    'base_on_ball',
    'hit_by_pitch',
    'steal_caught',
  ],
  mma: [
    'quick_win',
    'win',
    'win_decision',
  ],
  csgo: [
    'kill',
    'death',
    'bomb_planted',
    'bomb_defused',
    'target_bombed',
    'five_kills',
    'time_expired',
    'suicide',
    'flash_assist',
    'map_win',
    'round_started',
    'round_ended',
    'half_started',
    'half_ended',
    'map_started',
    'map_ended',
    'match_started',
    'match_ended',
  ],
  e_football: [
    'e_goal',
    'win_by_default',
    'shot_on_goal',
    'penalty_save',
    'comeback',
    'card',
  ],
  lol: [
    'kill',
    'assist',
    'death',
    'turret_takedown_team',
    'first_blood',
    'baron_team_kill',
    'dragon_team_kill',
    'rift_herald_team_kill',
    'creep_difference',
    'win',
    'win_in_under_thirty_minutes',
    'win_in_under_thirtyfive_minutes',
    'dragon_steal',
    'baron_steal',
    'map_started',
    'map_ended',
    'map_win',
  ],
  handball: [
    'goal',
    'miss',
    'penalty_miss',
    'penalty_save',
    'assist',
    'steal',
    'save',
    'conceded_goal',
    'card',
    'two_minute',
    'penalty_induce',
  ],
}

for(const key of Object.keys(mainEvents)) {
  mainEvents[key] = mainEvents[key].concat(['ping'])
}

const eventNames = {
  first_blood: 'First Blood',
  turret_takedown: 'Turret Takedown',
  baron: 'Baron',
  dragon_kill: 'Dragon Kill',
  goal: 'Goal',
  e_goal: 'Goal',
  freekick_goal: 'Freekick Goal',
  last_minute_goal: 'Last Minute Goal',
  substitution_0: 'Sub',
  shot_on_goal: 'Shot on Goal',
  comeback: 'Comeback',
  substitution_1: 'Sub',
  keeper_save: 'Save',
  team_victory: 'Team victory',
  overtime_victory: 'Overtime victory',
  overtime_loss: 'Overtime loss',
  penalty_save: 'Penalty save',
  penalty_goal: 'Penalty goal',
  penalty_miss: 'Penalty miss',
  card: 'Card',
  penalty_round: 'Penalty Round',
  penalty_round_goal: 'PR Goal',
  penalty_round_miss: 'PR Miss',
  penalty_round_save: 'PR Save',
  yellow_card: 'Yellow card',
  red_card: 'Red card',
  bonus: 'Bonus',
  bonus1: '+1',
  bonus2: '+2',
  bonus3: '+3',
  man_of_the_match: 'MotM',
  own_goal: 'Own goal',
  blunder: 'Blunder',
  foul_commited: 'Foul Commited',
  fouls_drawn: 'Foul Drawn',
  penalty: 'Penalty',
  shootout_caused: 'Shootout caused',
  shootout_won: 'Bullets won',
  shootout_goal: 'Shootout goal',
  clean_sheet: 'Clean sheet',
  assist: 'Assist',
  plus: 'Plus',
  minus: 'Minus',
  even: 'Even',
  power: 'PPG',
  box: 'BPG',
  threepoint_goal: 'Threepoint Goal (3P)',
  field_goal: 'FIeld Goal (2P)',
  freethrow_goal: 'Freethrow Goal (1P)',
  kill: 'Kill',
  death: 'Death',
  deny_teammate: 'Deny teammate',
  denies: 'Denies',
  tower_kill: 'Killed tower',
  rosnal_kill: 'Killed Roshan',
  snatch_aegis: 'Snatched aegis',
  curling_end: 'End',
  wicket: 'Wicket',
  duck_dismissal: 'Dis. for a duck',
  caught: 'Catch',
  stumping: 'Stumping',
  run_out: 'Run-out',
  run_out_thrown: 'Run-out thrown',
  run_out_caught: 'Run-out caught',
  extras: 'Extras',
  try_goal: 'Try',
  drop_goal: 'Drop goal',
  drop_goal_penalty: 'Penalty kick',
  conversion: 'Conversion',
  conversion_miss: 'Conversion miss',
  assist_fantasy: 'Fantasy ast.',
  penalty_caused: 'Penalty Caused',
  scoring_freekick_caused: 'Scoring Freekick Caused',
  assist_own_goal: 'Assist Own Goal',
  point: 'Point',
  tbi: 'TBI',
  win_by_default: 'Win By Default',
  ping: 'Ping',
  ball_out_of_play: 'Ball out of Play',
  touchdown: 'Touchdown',
  passing_td: 'Passing TD',
  rushing_td: 'Rushing TD',
  receiving_td: 'Receiving TD',
  fumble_recovery_td: 'Fumble Recovery TD',
  extra_point: 'Extra Point',
  first_man_of_the_match: 'First Man of the Match',
  second_man_of_the_match: 'Second Man of the Match',
  third_man_of_the_match: 'Third Man of the Match',
  shooting_relay: 'One Round of Target Shooting',
  shooting_other: 'One Round of Target Shooting',
  scored_run: 'Scored Run',
  strikeout: 'Strikeout',
  single: 'Single',
  double: 'Double',
  triple: 'Triple',
  home_run: 'Homerun',
  stolen_base: 'Stolen Base',
  earned_run: 'Earned Run',
  inning_pitched: 'Inning Pitched',
  hit_against: 'Hit Against',
  lost_base: 'Lost Base',
  batter_hit: 'Batter Hit',
  rbi: 'Run Batted In',
  base_on_ball: 'Base on Ball',
  hit_by_pitch: 'Hit by Pitch',
  steal_caught: 'Caught Stealing',
  pass: 'Pass',
  takedown: 'Succesful Takedown',
  reversal: 'Sweep / Reversal',
  knockdown: 'Knockdown',
  win: 'Win',
  draw: 'Draw',
  win_decision: 'Win by Decision',
  performance_of_the_night: 'Performance of the Night',
  fight_of_the_night: 'Fight of the Night',
  quick_win: 'Quick Win',
  quick_sets: 'Quick Sets',
  game_won: 'Game Won',
  ace: 'Ace',
  double_fault: 'Double Fault',
  break_won: 'Break Won',
  retired: 'Retired',
  round_win: 'Round Win',
  bomb_planted: 'Bomb Planted',
  bomb_defused: 'Bomb Defused',
  map_win: 'Map Win',
  suicide: 'Suicide',
  flash_assist: 'Flash Assist',
  round_started: 'Round Started',
  round_ended: 'Round Ended',
  half_started: 'Half Started',
  half_ended: 'Half Ended',
  map_started: 'Map Started',
  map_ended: 'Map Ended',
  match_started: 'Match Started',
  match_ended: 'Match Ended',
  five_kills: 'Five Kills',
  target_bombed: 'Target Bombed',
  time_expired: 'Time Expired',
  kill_headshot: 'Kill Headshot',
  kill_knife: 'Kill Knife',
  kill_grenade: 'Kill Grenade',
  teamkill: 'Team Kill',
  creep_kill: 'Creep Kill',
  creep_deny: 'Creep Deny',
  building_destruction: 'Building Destruction',
  roshan_kill: 'Roshan Kill',
  wards_placed: 'Wards Placed',
  wards_destroyed: 'Wards Destroyed',
  camp_stack: 'Camp Stack',
  core_camp_stack: 'Core Camp Stack',
  rune_pickup: 'Rune Pickup',
  hero_healing: 'Hero Healing',
  courier_kill: 'Courier Kill',
  stun: 'Stun',
  SSB: 'Straight Set Bonus',
  knocked_out: 'Knocked Out',
  save_penalty: 'Penalty Save',
  cause_freekick_goal: 'Cause Freekick Goal',
  save: 'Save',
  cause_penalty_goal: 'Cause Penalty Goal',
  penalty_induce: 'Induce Penalty',
  penalty_cause: 'Cause Penalty',
  two_minute: 'Two Minute',
  miss: 'Miss',
  conceded_goal: 'Conceded Goal',
  steal: 'Steal',
  shot_on_target: 'Shot on Target',
  aegis_snatched: 'Aegis Snatched',
  turret_takedown_team: 'Turret Takedown',
  baron_team_kill: 'Baron Kill',
  dragon_team_kill: 'Dragon Kill',
  rift_herald_team_kill: 'Rift Herald Kill',
  creep_difference: 'Creep Difference',
  win_in_under_thirty_minutes: 'WU30',
  win_in_under_thirtyfive_minutes: 'WU35',
  dragon_steal: 'Dragon Steal',
  baron_steal: 'Baron Steal',
}

class EventState {
  constructor(match) {
    this.match = match
    if(this.match.playOffStage) {
      mainEvents[this.match.sport] = mainEvents[this.match.sport].concat(['overtime_victory'])
    }
    this.renderSet = new Set()
    this.reloadSet = new Set()
    this.reset()
  }

  listen(component, reload) {
    this.renderSet.add(component)
    if(reload) this.reloadSet.add(component)
  }

  render() {
    for(var component of this.renderSet) {
      component.render()
    }
  }

  reload(force) {
    if(this.$promise) return
    this.$promise = this.match.load({ $reload: force })
    this.$promise
      .then(() => {
        for(var component of this.reloadSet) {
          component.update(this.$promise)
        }
      })
      .catch(err => console.error(err))
      .then(() => {
        delete this.$promise
      })
  }

  reset() {
    this.event = new Event()
    this.event.minute = this.match.events
      ? this.match.events.reduce((n, e) => Math.max(n, e.minute), 0)
      : 0
    this.event.minute += 1
    this.event.second = 0
    this.subEvents = []
    this.state = 'main'
    if(this.sport === 'curling') {
      this.event.name = 'curling_end'
    }
    this.advanceState()
  }

  eventName(ev) {
    return eventNames[ev]
  }

  isEvent(event) {
    if(event.match(/substitution/)) {
      return (this.event.name || '').match(/substitution/)
    }
    return this.event.name === event
  }

  assignMainType(type) {
    this.reset()
    this.event.name = type
    if(type === 'penalty') this.event.duration = 2
    if(type === 'curling_end') this.event.duration = 1
    if(type === 'goal') this.event.subType = 'even'
    if(type === 'team_victory') this.event.subType = 'team_victory'
    if(type === 'bonus') this.event.subType = 'man_of_the_match'
    if(type === 'card') this.event.subType = 'yellow_card'
    if(type === 'penalty_round') this.event.subType = 'penalty_round_goal'
    if(type === 'touchdown') this.event.subType = 'passing_td'
    if(type === 'quick_sets') this.event.quickSets = [[0, 0]]
    this.advanceState()
  }

  assignMinute(val) {
    this.event.minute = val
    this.render()
  }

  assignSecond(val) {
    this.event.second = val
    this.render()
  }

  assignMillisecond() {
    if(this.sport === 'csgo') {
      this.event.millisecond = (((this.event.minute % 1000) % 10) * 60 + this.event.second) * 1000
    } else {
      this.event.millisecond = ((this.event.minute * 60) + this.event.second) * 1000
    }
  }

  assignBatch(val) {
    this.event.batch = val
    this.event.minute = (this.event.minute % 1000) + (this.event.batch * 1000)
  }

  get round() {
    return Math.floor(((this.event.minute % 1000) / 10))
  }

  assignDuration(val) {
    if(!~this.durations.indexOf(val)) return
    this.event.duration = val
    this.render()
  }

  assignPlayer(player) {
    if((player.player === this.event.player) && this.sport !== 'e_football') {
      this.event.player = null
      this.state = 'main'
      return this.render()
    }
    var existing = this.subEvents.find(e => e.player === player.player)
    if(existing && (this.sport !== 'e_football')) {
      this.subEvents.splice(this.subEvents.indexOf(existing), 1)
      return this.advanceState()
    }
    var ev
    switch(this.state) {
      case 'main':
        this.event.player = player.player
        this.event.team = player.team
        this.event.batch = player.batch
        break
      case 'substitution_1':
      case 'substitution_0':
        if(this.subEvents.length) {
          ev = this.subEvents[0]
        } else {
          ev = new Event()
          this.subEvents.push(ev)
        }
        ev.player = player.player
        ev.team = player.team
        ev.name = this.state
        break
      default:
        const count = this.countEvents(this.state)
        const max = this.maxEvents(this.state)
        if(max === 1 && count) {
          ev = this.subEvents[0]
          if(ev) {
            ev.player = player.player
            ev.name = this.state
            break
          }
        }
        if(count >= max) return
        ev = new Event()
        ev.player = player.player
        ev.name = this.state
        ev.batch = player.batch
        this.subEvents.push(ev)
    }
    this.advanceState()
  }

  assignTeam(team) {
    if(team === this.event.team) return
    this.event.team = team
    this.advanceState()
  }

  changeName(name) {
    if(name === this.event.name) return
    this.event.name = name
    this.event.validity = 'protected'
    this.advanceState()
  }
  assignOriginal(original) {
    this.event = original
    this.subEvents = original.subEvents
    const name = original.name
    const [subEvent] = this.subEvents
    if(name === 'goal' && this.sport === 'hockey') {
      this.event.subType = 'even'
    } else if(name === 'power_play_goal') {
      this.event.name = 'goal'
      this.event.subType = 'power'
      for(const e of this.subEvents) e.name = 'assist'
    } else if(name === 'box_play_goal') {
      this.event.name = 'goal'
      this.event.subType = 'box'
      for(const e of this.subEvents) e.name = 'assist'
    } else if(
      ['yellow_card', 'red_card'].includes(name) &&
      ['football', 'e_football'].includes(this.sport)
    ) {
      this.event.subType = name
      this.event.name = 'card'
    } else if(['penalty_caused', 'scoring_freekick_caised'].includes(name)) {
      this.event.subType = name
      this.event.name = 'blunder'
    }
    if(this.event.name === 'goal' && this.sport === 'football' && subEvent && subEvent.player) {
      if(subEvent.name === 'assist_fantasy') {
        this.event.subType = 'assist_fantasy'
      }
      if(subEvent.name === 'assist_tbi') {
        this.event.subType = 'tbi'
      }
      subEvent.name = 'assist'
    }
    this.render()
  }

  advanceState() {
    this.render()
    if(!this.event.name || !this.event.player) return
    var key = `advanceState_${this.event.name}`
    if(this[key]) return this[key]()
  }

  advanceState_goal() {
    if(this.countEvents(this.state) < this.maxEvents(this.state)) return
    if(this.sport === 'handball') {
      this.state = 'conceded_goal'
    } else {
      this.state = 'assist'
    }
  }

  advanceState_e_goal() {
    this.state = 'last_minute_goal'
  }

  advanceState_last_minute_goal() {
    this.state = 'freekick_goal'
  }

  advanceState_try_goal() {
    this.state = 'assist'
  }

  advanceState_substitution_1() {
    this.advanceState_substitution_0()
  }

  advanceState_substitution_0() {
    var lineup = this.match.lineups.find(l => l.player === this.event.player)
    var isOn = !!lineup.advancedIsOn(this.event.seconds)
    this.event.name = `substitution_${+isOn}`
    this.state = `substitution_${+!isOn}`
  }

  advanceState_run_out_thrown() {
    this.state = 'run_out_caught'
  }

  advanceState_caught() {
    this.state = 'wicket'
  }

  advanceState_duck_dismissal() {
    this.state = 'wicket'
  }

  advanceState_stumping() {
    this.state = 'wicket'
  }

  countEvents(type) {
    return this.subEvents.filter(e => e.name === type).length
  }

  maxEvents(type) {
    switch(type) {
      case 'main':
        return 0
      case 'assist':
        return this.sport === 'hockey' ? 2 : 1
      default:
        return 1
    }
  }

  async submit() {
    if(!this.isReady) return
    if(this.isSubmitting) return
    this.isSubmitting = true
    const data = this.data
    if(this.match.lockedEvents &&
      this.match.lockedEvents.length) {
      const question = `
        This match has lockedEvents. Do you still want to
        submit this event change?
      `
      const confirmation = await prompt(question, {
        type: 'custom',
        level: 'danger',
        submitBtnName: 'Do it',
        cancelBtnName: 'Abort',
      })
      data.replaceLockedEvents = true
      if(!confirmation) return
    }
    try {
      await this.match.post('events', data)
      this.reset()
      await this.reload(true)
    } catch (e) {
      console.error(e)
    }
    this.isSubmitting = false
  }

  get data() {
    const ret = {
      event: {
        _id: this.event._id,
        minute: this.event.minute,
        second: this.event.second,
        name: this.event.name,
        match: this.match._id,
        player: this.event.playerId,
        team: this.event.teamId,
        duration: this.event.duration,
        batch: this.event.batch,
        millisecond: this.event.millisecond,
        quickSets: this.isQuickSets && this.event.quickSets,
      },
      subEvents: this.subEvents.map(e => {
        return {
          _id: e._id,
          minute: this.event.minute,
          second: this.event.second,
          name: e.name,
          match: this.match._id,
          millisecond: this.event.millisecond,
          batch: this.event.batch,
          team: this.event.teamId,
          player: e.playerId,
        }
      }),
    }

    if(this.event.name === 'keeper_save') {
      for(var i = 1; i < this.event.duration; ++i) ret.subEvents.push(ret.event)
      ret.event.duration = 0
    } else if(this.sport === 'hockey' && this.event.name === 'goal') {
      ret.subEvents.filter(e => e.name === 'assist').forEach(e => {
        e.name = {
          even: 'assist',
          power: 'power_play_assist',
          box: 'box_play_assist',
        }[this.event.subType]
      })

      // Correct goal type
      ret.event.name = {
        even: 'goal',
        power: 'power_play_goal',
        box: 'box_play_goal',
      }[this.event.subType]
    } else if(['team_victory'].includes(this.event.name && this.event.subType)) {
      ret.event.name = this.event.subType
    } else if(this.sport === 'football' && this.event.name === 'goal') {
      switch(this.event.subType) {
        case 'assist_fantasy':
          ret.subEvents = ret.subEvents.filter(e => e.player)
          for(const e of ret.subEvents) e.name = 'assist_fantasy'
          break
        case 'tbi':
          ret.subEvents = [{
            minute: this.event.minute,
            second: this.event.second,
            name: 'assist_tbi',
            match: this.match._id,
            team: this.event.team,
          }]
          break
        default:
          ret.subEvents = ret.subEvents.filter(e => e.player)
          break
      }
    } else if(this.event.name === 'own_goal') {
      const playerTeam = this.event.player.team
      const [team] = this.match.teams.filter(t => t._id !== playerTeam._id)
      ret.event.team = team._id
      for(const e of ret.subEvents) e.team = team._id
    } else if(this.event.name === 'bonus') {
      ret.event.name = this.event.subType || 'man_of_the_match'
    } else if(this.event.name === 'blunder') {
      ret.event.name = this.event.subType || 'penalty_caused'
    } else if(this.event.name === 'card') {
      ret.event.name = this.event.subType || 'yellow_card'
    } else if(this.event.name === 'penalty_round') {
      ret.event.name = this.event.subType || 'penalty_round_goal'
    } else if(this.event.name === 'team_victory') {
      ret.event.name = this.event.subType || 'team_victory'
    } else if(this.event.name === 'touchdown') {
      ret.event.name = this.event.subType || 'passing_td'
    } else if(this.event.name === 'win') {
      ret.event.name = this.event.subType || 'win'
    }
    return ret
  }
  get easyNameChange() {
    const winTypes =
    [
      'five_kills',
      'bomb_defused',
      'target_bombed',
      'time_expired',
    ]
    if(winTypes.includes(this.event.name)) {
      return winTypes.filter(z => z !== this.event.name)
    }
    return false
  }

  get mainEvents() {
    return mainEvents[this.sport] || []
  }

  get rounds() {
    if(this.sport === 'curling') return ['End']
    const periods = this.periods
    return periods.map((_, i) => i + 1)
  }

  get sport() {
    return this.match.sport
  }

  get periods() {
    if(this.sport === 'csgo') {
      return [5]
    }
    if(this.sport === 'lol') {
      return [100]
    }
    return rules(this.sport).periods() || [100, 100]
  }

  roundStart(round) {
    var ret = 0
    const periods = this.periods
    for(var i = 1; i < round; ++i) {
      ret += periods[i - 1] || 0
    }
    return ret
  }

  roundEnd(round) {
    var ret = 0
    const periods = this.periods
    for(var i = 0; i < round; ++i) {
      ret += (periods || [100])[i] || 0
    }
    return ret
  }

  get lastMinute() {
    return this.roundStart(this.rounds.length + 1)
  }

  get subCategories() {
    if(this.sport === 'e_football') {
      return {
        e_goal: ['last_minute_goal', 'freekick_goal'],
      }[this.event.name]
    }
    if(this.sport === 'handball') {
      return {
        goal: ['conceded_goal'],
      }[this.event.name]
    }
    return {
      goal: ['assist'],
      e_goal: ['last_minute_goal', 'freekick_goal'],
      own_goal: ['assist_own_goal'],
      substitution_1: ['substitution_0'],
      substitution_0: ['substitution_1'],
      run_out_thrown: ['run_out_caught'],
      caught: ['wicket'],
      duck_dismissal: ['wicket'],
      stumping: ['wicket'],
      try_goal: ['assist'],
      kill: ['death', 'assist'],
    }[this.event.name]
  }
  get durations() {
    switch(this.event.name) {
      case 'penalty':
        return [2, 4, 5, 10, 20]
      case 'touchdown':
        return Array(100).fill(1).map((_, i) => i + 1)
      case 'curling_end':
        return [1, 2, 3, 4, 5, 6, 7, 8]
      case 'extras':
        return Array(1000).fill(1).map((_, i) => i + 1)
      default:
        return []
    }
  }

  canBeTeamEvent(event) {
    return [
      'curling_end',
      'extras',
      'goal',
      'threepoint_goal',
      'field_goal',
      'freethrow_goal',
      'extra_point',
      'shootout_won',
      'bomb_planted',
      'round_win',
      'map_win',
      'won',
      'round_ended',
      'match_ended',
      'time_expired',
      'target_bombed',
      'bomb_defused',
      'five_kills',
      'overtime_victory',
      'baron_team_kill',
      'dragon_team_kill',
      'rift_herald_team_kill',
      'win',
      'win_in_under_thirty_minutes',
      'win_in_under_thirtyfive_minutes',
      'turret_takedown_team',
    ].includes(event.name)
  }

  canBeMatchEvent(event) {
    return [
      'quick_sets',
      'ping',
      'ball_out_of_play',
      'match_started',
      'half_started',
      'half_ended',
      'map_started',
      'map_ended',
      'round_started',
      'round_ended',
      'SSB',
    ].includes(event.subType || event.name)
  }

  get isReady() {
    return (
      (this.event.player && this.event.name) ||
      (this.event.team && this.canBeTeamEvent(this.event)) ||
      (this.canBeMatchEvent(this.event))
    )
  }

  get subTypes() {
    if(this.sport === 'hockey' && this.event.name === 'goal') {
      return ['even', 'power', 'box']
    } else if(this.sport === 'football' && this.event.name === 'goal') {
      return ['assist', 'assist_fantasy', 'tbi']
    } else if(this.event.name === 'team_victory') {
      return ['team_victory', 'overtime_victory', 'overtime_loss']
    } else if(this.event.name === 'blunder') {
      return ['penalty_caused', 'scoring_freekick_caused']
    } else if(this.event.name === 'bonus') {
      return ['man_of_the_match', 'second_man_of_the_match', 'third_man_of_the_match', 'bonus1', 'bonus2', 'bonus3']
    } else if(this.event.name === 'card') {
      return ['yellow_card', 'red_card']
    } else if(this.event.name === 'penalty_round') {
      return ['penalty_round_goal', 'penalty_round_miss', 'penalty_round_save']
    } else if(this.event.name === 'touchdown') {
      return ['passing_td', 'rushing_td', 'receiving_td', 'fumble_recovery_td']
    } else if(this.event.name === 'round_win') {
      return ['five_kills', 'target_bombed', 'bomb_defused', 'time_expired']
    } else if(this.event.name === 'kill') {
      if(this.sport === 'csgo') {
        return ['kill_headshot', 'kill_knife', 'kill_grenade', 'teamkill']
      } else {
        return []
      }
    } else {
      return []
    }
  }

  get player() {
    return this.event.player
  }

  get team() {
    return this.event.team
  }

  get quickSets() {
    return this.event.quickSets
  }

  get isQuickSets() {
    return this.event.name === 'quick_sets'
  }
}

export default function getState(match) {
  return states[match] || (states[match] = new EventState(match))
}
